// extracted by mini-css-extract-plugin
export default {"layout":"System_layout__FqmJ6","content":"System_content__MxT1E"};